<template>
  <nav>
    <div class="version">
      <span>Versão: v{{ version }}</span>
    </div>
    <ul class="nav flex-column">
      <li class="nav-item">
        <router-link class="itemmenu" :class="{ active: route.name === 'dashboard' }" to="/"><i class="bi bi-speedometer2 me-2"></i> Visão geral</router-link>
      </li>
      <li class="nav-item">
        <router-link class="itemmenu" :class="{ active: route.name === 'clients' || route.name === 'client-detail' }" to="/clients"><i class="bi bi-shop me-2"></i> Clientes</router-link>
      </li>
      <li class="nav-item">
        <router-link class="itemmenu" :class="{ active: route.name === 'plans' }" to="/plans"><i class="bi bi-card-checklist me-2"></i> Planos</router-link>
      </li>
      <li class="nav-item">
        <a class="itemmenu" href="#" @click.prevent="logout"><i class="bi bi-box-arrow-left me-2"></i> Sair</a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { useRoute } from 'vue-router';
import { useAuth } from '@/services/auth.js';

export default {
  name: 'Navbar',
  setup() {
    const auth = useAuth();
    const route = useRoute();
    const version = '0.1.0'

    function logout() {
      auth.logout();
    }

    return { logout, version, route }
  }
}
</script>

<style scoped>
  .version {
    color: #7d868f;
    font-size: 12px;
    padding: 0 0.5em 1em;
  }

  .itemmenu {
    padding: 0.6em 0.75em;
    margin-bottom: 0.15em;
    border-radius: 10px;
    color: #a8a8a8;
    display: block;
    text-decoration: none;
    font-size: 0.95rem;
    transition: background-color 0.15s ease, color 0.15s ease;
  }

  .itemmenu:hover {
    color: #ffffff;
    background-color: rgba(255, 255, 255, 0.08);
  }

  .itemmenu.active {
    color: #ffffff;
    background-color: var(--brand, #6f42c1);
  }
</style>
